import Vue from "vue";

export default {
    version: "3.1", 
    BASE_URL: 'https://qualdent.brk-dev.ro/api/index.php/',

    set_token: function(newToken) {
        window.localStorage.setItem("chestionare-umfd-token", newToken);
        Vue.http.headers.common["Token"] = newToken;
    },

    set_info_completare(info){
        var existingStr  = window.localStorage.getItem("info-completat-deja");
        if( existingStr == null ) existingStr = "[]";
        var existing     = JSON.parse( existingStr );
        if( existing.includes(info) ){
            return false;
        } else {
            existing.push(info);
            window.localStorage.setItem("info-completat-deja", JSON.stringify( existing ) );
            return true;
        }
    },


    get_token: function() {
        return window.localStorage.getItem("chestionare-umfd-token");
    },

    set_drepturi: function (drepturi) {
        window.localStorage.setItem('chestionare-umfd-drepturi_user', JSON.stringify(drepturi));
    },

    get_drepturi: function () {
        var drepturi = window.localStorage.getItem('chestionare-umfd-drepturi_user');
        return JSON.parse(drepturi);
    },
    set_user_type: function (user_type) {
        window.localStorage.setItem('chestionare-umfd-user_type', user_type);
    },

    get_user_type: function () {
        return window.localStorage.getItem('chestionare-umfd-user_type');
    },

    is_logged_in: function() {
        var token = this.get_token();
        return token !== "";
    },

    logout: function() {
        this.set_token('');
        this.set_drepturi('');
    },

    verify_response: function(response) {
        if (response.body.NotLogged) {
            return false;
        }
        return true;
    },

    verify_login_and_redirect: function(vueInstance) {
        if (!this.is_logged_in()) {
            vueInstance.$router.push("/");
        }
    },
};
